module.exports = __webpack_public_path__ + "static/media/img-jornada.ba688ae8.jpeg";